import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Features from '../components/Features';
import HowToPlay from '../components/HowToPlay';
import NFTAssets from '../components/NFTAssets';
import Tokenomics from '../components/Tokenomics';
import Roadmap from '../components/Roadmap';
import Community from '../components/Community';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="bg-black">
      <Header />
      <Hero />
      <Features />
      <HowToPlay />
      <NFTAssets />
      <Tokenomics />
      <Roadmap />
      <Community />
      <FAQ />
      <Footer />
    </div>
  );
};

export default HomePage;
